import { useQuery } from 'react-query';
import { format, parseISO } from 'date-fns';
import api from '../services/api';

const FORMAT_MAP = {
  'DD/MM/YYYY': 'dd/MM/yyyy',
  'MM/DD/YYYY': 'MM/dd/yyyy',
  'YYYY-MM-DD': 'yyyy-MM-dd'
};

export const useDateFormat = () => {
  const { data: settings } = useQuery('system-settings', async () => {
    const res = await api.get('/settings/system');
    return res.data.data;
  }, {
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000
  });

  const dateFormat = settings?.dateFormat || 'DD/MM/YYYY';
  const fnsFormat = FORMAT_MAP[dateFormat] || 'dd/MM/yyyy';

  const formatDate = (date) => {
    if (!date) return '-';
    try {
      const d = typeof date === 'string' ? parseISO(date) : new Date(date);
      return format(d, fnsFormat);
    } catch {
      return '-';
    }
  };

  return { formatDate, dateFormat };
};
